

























































































import VueFileUpload from 'vue-upload-component';
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import { FileHelper } from '@/helper/file.helper';
import { FileUploadDataViewModel } from '@/Alynk.dtos';
import { v4 as uuidv4 } from 'uuid';
import { Base } from "@/components/common/base";
import * as marked from 'marked';
import VueUploadComponent from "vue-upload-component";
import { IFileUploaderOption } from '@/models/fileUploader';
import { appInsights } from '@/main';
import { Utils } from '@/helper/utils';

@Component({
    props: ['options'],
    watch: {
        // Watch for changes in the upload button loading state
        uploadBtnLoading(newValue) {
            if (newValue) {
                this.disableClickListener(); // Disable the listener when loading
            }
        }
    },
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },

    },
    components: {
        FileUpload: VueFileUpload,
    },
})

export default class FileUploaderComponent extends Base {
    public options: IFileUploaderOption;
    public selectedFiles = [];
    public dragclass: string = "";
    public uploadBtnLoading: boolean = false;
    public dragging: boolean = false;
    public multiple: boolean = false;
    public showIcon: boolean = false;
    public extensions: string[] = [];
    public attachmentFiles: FileUploadDataViewModel[] = [];
    public totalFileSizeInBytes: number = 0;
    public isValidExtension: boolean = false;
    public async onChange() {
        if (this.options.inputFiles && this.options.inputFiles.length > 0) {
            try {

                if (this.attachmentFiles.length > 0 && !this.options.multiple) {
                    this.showAlert(false, "Only one file can be uploaded.");
                    return;
                }

                this.isValidExtension = this.checkFileExtensions(this.options);
                if (!this.isValidExtension) {
                    return;
                }

                for (let i = 0; i < this.options.inputFiles.length; i++) {
                    if (this.options.inputFiles[i]) {
                        const currentFile = this.options.inputFiles[i].file;
                         const fileSize = currentFile.size;
                        // Check if file size exceeds 100MB
                        if (fileSize > 100 * 1024 * 1024) {
                            this.showAlert(false, "Max size 100 MB. You can't upload more than 100 MB.");
                            return;
                        }
                    }
                }

                this.uploadBtnLoading = true;
                this.$emit('fileUploadprogress', true);
                let isFileAlreadyProcessed = false;
                this.options.inputFiles.forEach((file) => {
                    if (file.file) {
                        isFileAlreadyProcessed = this.selectedFiles.some(
                            (existingFile) => existingFile.name === file.file.name && existingFile.size === file.file.size
                        );
                    }
                });

                if (!isFileAlreadyProcessed) {

                    this.options.inputFiles.forEach((file) => {
                        if (file.file) {
                            this.selectedFiles.push(file.file);
                        }
                    });

                    for (let i = 0; i < this.options.inputFiles.length; i++) {

                        if (this.options.inputFiles[i]) {

                            const currentFile = this.options.inputFiles[i].file;
                            if (currentFile) {

                                const fileSize = currentFile.size;
                                this.totalFileSizeInBytes += fileSize;
                                const fileName = currentFile.name;
                                const extension = fileName.substring(
                                    fileName.lastIndexOf(".")
                                );
                                const base64 = await FileHelper.getFileByte(currentFile);
                                this.attachmentFiles.push({
                                    base64,
                                    extension,
                                    fileName,
                                    fileSize
                                });
                            }
                        }
                    }

                    this.evaluteFileSize(this.totalFileSizeInBytes);

                }
                else {
                    this.showAlert(false, "Duplicate files uploaded!. Please upload unique files only");
                }


            } catch (ex) {

                appInsights.trackEvent({ name: this.options.ref + ' Exception', properties: { message: "Exception in processing Files. Exception- " + ex.message, inputFiles: this.options.inputFiles } });

            } finally {

                this.options.inputFiles = [];
                this.$emit('updateFiles', this.options.inputFiles, this.attachmentFiles);
                if (this.selectedFiles && this.selectedFiles.length > 0) {
                    this.$emit('input', this.selectedFiles);
                }
                this.$emit('onchange', this.selectedFiles, this.$refs[this.options.ref]);
                this.$emit('fileUploadprogress', false);
                this.uploadBtnLoading = false;

            }
        }
    }
    public evaluteFileSize(fileSizeInByte: number): void {
        const totalFileSizeInMB = Math.floor(this.totalFileSizeInBytes / (1024 * 1024));
        if (totalFileSizeInMB >= Utils.maxTotalFileSize) {
            this.showAlert(false, `Total file size must be less than ${Utils.maxTotalFileSize} Mb, Please Upload Again`);
            this.resetFileList();
        }
    }
public formatFileSize(bytes: number): string {
    if (!bytes) return "0 Bytes";

    if (bytes < 1024) {
        return bytes + " Bytes";
    }

    const kb = bytes / 1024;
    if (kb < 1024) {
        return kb.toFixed(2) + " KB";
    }

    const mb = kb / 1024;
    return mb.toFixed(2) + " MB";
}
    public dragOver() {
        this.dragging = true;
        this.dragclass = 'dragged';
    }
    public dragLeave() {
        this.dragging = false;
        this.dragclass = '';
    }
    public selectFile() {
        if (this.uploadBtnLoading) {
            return; // Stop the function if the button is disabled
        }
        let element = this.$refs[this.options.ref]['$el'].querySelector('input');
        // Make sure the element exists before clicking
        if (element) {
            element.click();
        }
    }
    public removeFile(index) {
        if (this.uploadBtnLoading) {
            return;
        }
        const removedFile = this.selectedFiles[index];
        const removedfileSize = this.selectedFiles[index].size;
        this.attachmentFiles = this.attachmentFiles.filter((attachment) => {
            return !(
                removedFile.name === attachment.fileName &&
                removedFile.size === attachment.fileSize
            );
        });
        this.totalFileSizeInBytes -= removedfileSize;
        this.selectedFiles.splice(index, 1);
        this.$emit('updateFiles', this.options.inputFiles, this.attachmentFiles);

    }
    public disableClickListener() {
        let element = this.$refs[this.options.ref]['$el'].querySelector('input');
        if (element) {
            // Remove the event listener if the button is disabled
            element.removeEventListener('click', () => { });
        }
    }

    public beforeDestroy() {
        // Clean up the event listener when the component is destroyed
        let element = this.$refs[this.options.ref]['$el'].querySelector('input');
        if (element) {
            element.removeEventListener('click', () => { });
        }
        this.attachmentFiles = [];
    }
    public resetFileList() {
        this.selectedFiles = [];
        this.attachmentFiles = [];
        this.options.inputFiles = [];
        this.totalFileSizeInBytes = 0;
        this.$emit('updateFiles', this.options.inputFiles, this.attachmentFiles);
    }
    public mounted() {
        let element = null;
        if (this.$refs && this.$refs[this.options.ref]) {
            const refElement = this.$refs[this.options.ref];
            if (refElement['$el']) {
                element = refElement['$el'].querySelector('input');
            }
        }

        if (element) {
            element.addEventListener('click', () => { });
        }
        this.$root.$on('resetFileList', (ref) => {
            if (ref === this.options.ref) {
                this.resetFileList();
            }
        });
        if (this.options.ref) {
            this.$parent.$refs[this.options.ref] = this.$refs[this.options.ref];
        }
    }

    public checkFileExtensions(options) {
        if (!options?.extensions || !Array.isArray(options.extensions) || options.extensions.length === 0) {
            console.warn("No valid extensions provided for validation.");
            return true; //in that case user can upload anytype of file
        }

        const distinctExtensions = [...new Set(
            options.inputFiles
                .map(fileObj => {
                    const fileName = fileObj.name;
                    if (fileName && fileName.includes(".")) {
                        return fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
                    }
                    return ""; // Return an empty string if no valid extension found
                })
                .filter(ext => ext) // Filter out empty strings
        )];
        const normalizedExtensions = options.extensions.map(ext => ext.startsWith(".") ? ext.substring(1).toLowerCase() : ext.toLowerCase());
        const invalidExtensions = distinctExtensions.filter(ext => !normalizedExtensions.includes(ext));
        if (invalidExtensions.length > 0) {
            this.showAlert(
                false,
                `Invalid file extensions detected: ${invalidExtensions.join(", ")}. Please upload files with the following extensions: ${options.extensions.slice(0, 3).join(", ")}.`
            );
            return false;
        }
        return true;
    }
}


